import { configureStore } from '@reduxjs/toolkit';
import CartReducer from "../features/Cart/CartSlice";
import WishlistReducer from '../features/WishList/WishlistSlice';


const saveCartToLocalStorage = (state) => {
    if (!state) return;
    const data = JSON.stringify(state);
    localStorage.setItem('cartList', data);
};


const saveWishlistToLocalStorage = (state) => {
    if (!state) return;
    const data = JSON.stringify(state);
    localStorage.setItem('wishList', data);
};


const getCartFromLocalStorage = () => {
    const cartList = localStorage.getItem('cartList');
    return cartList ? JSON.parse(cartList) : [];
};


const getWishlistFromLocalStorage = () => {
    const wishList = localStorage.getItem('wishList');
    return wishList ? JSON.parse(wishList) : [];
};


export const store = configureStore({
    reducer: {
        Cart: CartReducer,
        Wishlist: WishlistReducer, 
    },
    preloadedState: {
        Cart: getCartFromLocalStorage(),
        Wishlist: getWishlistFromLocalStorage(),
    }
});


store.subscribe(() => {
    saveCartToLocalStorage(store.getState().Cart); 
    saveWishlistToLocalStorage(store.getState().Wishlist); 
});
